<template>
  <footer class="footer">
    <div class="container u-overflow--hidden">
      <div class="columns u-pl15 u-pr15 has-text-centered-mobile">
        <div class="column content  is-4-desktop is-6-widescreen is-7-fullhd">
          <a href="https://greenstorm.eu/" rel="noopener noreferrer" class="mb-5" v-if="$whitelabel.showFooterLogo"
            aria-label="Greenstorm Business">
            <img class="navbar-brand__logo" v-lazy="$whitelabel.logoFooter" :alt="$whitelabel.storeName" loading="lazy"
              fetchpriority="low" />
          </a>

          <!-- <p><a title="Kontakt" href="https://www.business.greenstorm.eu/kontakt" target="_blank" rel="noopener noreferrer">Kontakt</a></p> -->
        </div>
        <div class="column is-4-widescreen is-3-fullhd">
          <p class="title is-5 has-text-weight-bold">Kontakt</p>
          <p>
            Tel.:<a class="is-inline-block" v-if="$whitelabel.supportPhone" :href="`tel:${$whitelabel.supportPhone}`">{{
              $whitelabel.supportPhone }}</a><br />
            Mo-Fr. 08:00 - 17:00<br />
            E-Mail: <a class="is-inline-block" v-if="$whitelabel.supportMail"
              :href="`mailto:${$whitelabel.supportMail}`">{{ $whitelabel.supportMail }}</a>
          </p>
          <!-- <a href="https://www.facebook.com/GreenstormMarketplaceDE/" class="is-block mb-4 has-text-primary" target="_blank" rel="noopener noreferrer" title="Facebook"><i class="fab fa-facebook fa-3x"></i></a>
          <a href="https://www.youtube.com/channel/UCZ1-NF43ArW3OG_O36IUE7A" class="is-block mb-4 has-text-primary" target="_blank" rel="noopener noreferrer" title="Youtube"> <i class="fab fa-youtube fa-3x"></i></a>
          <a href="https://www.instagram.com/greenstorm.mobility/" class="is-block mb-4 has-text-primary" target="_blank" rel="noopener noreferrer" title="Instagram"> <i class="fab fa-instagram fa-3x"></i></a>
          <a href="https://www.linkedin.com/company/greenstorm-mobility/" class="is-block mb-4 has-text-primary" target="_blank" rel="noopener noreferrer" title="LinkedIn"> <i class="fab fa-linkedin fa-3x"></i></a>
          <a href="https://twitter.com/GreenstormEbike" class="is-block mb-4 has-text-primary" target="_blank" rel="noopener noreferrer" title="Twitter"> <i class="fab fa-twitter fa-3x"></i></a> -->
        </div>
        <div class="column  is-widescren-4  is-2-fullhd">
          <!-- <router-link v-for="page in $whitelabel.staticContent" :key="page.Menu" :to="{name: 'markdown-page', params: {key: page.slug}}" class=" is-block-mobile is-block-tablet footer-nav-link is-uppercase mb-4 is-size-5">{{ page.menu }}</router-link>
 -->
          <p class="title is-5 has-text-weight-bold">Service</p>
          <router-link class=" is-block-mobile is-block-tablet footer-nav-link  "
            :to="{ name: 'hotel-map' }">Hotelkarte</router-link>
          <router-link v-for="page in menu.footer" :key="page.slug"
            :to="{ name: 'markdown-page', params: { key: page.slug } }"
            class=" is-block-mobile is-block-tablet footer-nav-link ">{{ page.menu }}</router-link>
        </div>
        <!-- <div class="column">nix</div> -->
      </div>

      <div class="has-text-centered mt-6">
        <a href="https://www.facebook.com/GreenstormMarketplaceDE/" class="inline-block mx-2 mb-4 has-text-primary"
          target="_blank" rel="noopener noreferrer" title="Facebook">
          <svg fill="#ffffff" height="4rem" width="4rem" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-143 145 512 512" xml:space="preserve" stroke="#ffffff">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <path
                d="M329,145h-432c-22.1,0-40,17.9-40,40v432c0,22.1,17.9,40,40,40h432c22.1,0,40-17.9,40-40V185C369,162.9,351.1,145,329,145z M169.5,357.6l-2.9,38.3h-39.3v133H77.7v-133H51.2v-38.3h26.5v-25.7c0-11.3,0.3-28.8,8.5-39.7c8.7-11.5,20.6-19.3,41.1-19.3 c33.4,0,47.4,4.8,47.4,4.8l-6.6,39.2c0,0-11-3.2-21.3-3.2c-10.3,0-19.5,3.7-19.5,14v29.9H169.5z">
              </path>
            </g>
          </svg></a>

        <a href="https://www.youtube.com/channel/UCZ1-NF43ArW3OG_O36IUE7A"
          class="inline-block mx-2 mb-4 has-text-primary" target="_blank" rel="noopener noreferrer" title="Youtube">
          <svg fill="#ffffff" height="4rem" width="4rem" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-143 145 512 512" xml:space="preserve" stroke="#ffffff">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <g>
                <polygon points="78.9,450.3 162.7,401.1 78.9,351.9 "></polygon>
                <path
                  d="M329,145h-432c-22.1,0-40,17.9-40,40v432c0,22.1,17.9,40,40,40h432c22.1,0,40-17.9,40-40V185C369,162.9,351.1,145,329,145z M241,446.8L241,446.8c0,44.1-44.1,44.1-44.1,44.1H29.1c-44.1,0-44.1-44.1-44.1-44.1v-91.5c0-44.1,44.1-44.1,44.1-44.1h167.8 c44.1,0,44.1,44.1,44.1,44.1V446.8z">
                </path>
              </g>
            </g>
          </svg>
        </a>

        <a href="https://www.instagram.com/greenstorm.mobility/" class="inline-block mx-2 mb-4 has-text-primary"
          target="_blank" rel="noopener noreferrer" title="Instagram">
          <svg fill="#ffffff" height="4rem" width="4rem" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-143 145 512 512" xml:space="preserve" stroke="#ffffff">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <g>
                <path
                  d="M113,446c24.8,0,45.1-20.2,45.1-45.1c0-9.8-3.2-18.9-8.5-26.3c-8.2-11.3-21.5-18.8-36.5-18.8s-28.3,7.4-36.5,18.8 c-5.3,7.4-8.5,16.5-8.5,26.3C68,425.8,88.2,446,113,446z">
                </path>
                <polygon points="211.4,345.9 211.4,308.1 211.4,302.5 205.8,302.5 168,302.6 168.2,346 "></polygon>
                <path
                  d="M329,145h-432c-22.1,0-40,17.9-40,40v432c0,22.1,17.9,40,40,40h432c22.1,0,40-17.9,40-40V185C369,162.9,351.1,145,329,145z M241,374.7v104.8c0,27.3-22.2,49.5-49.5,49.5h-157C7.2,529-15,506.8-15,479.5V374.7v-52.3c0-27.3,22.2-49.5,49.5-49.5h157 c27.3,0,49.5,22.2,49.5,49.5V374.7z">
                </path>
                <path
                  d="M183,401c0,38.6-31.4,70-70,70c-38.6,0-70-31.4-70-70c0-9.3,1.9-18.2,5.2-26.3H10v104.8C10,493,21,504,34.5,504h157 c13.5,0,24.5-11,24.5-24.5V374.7h-38.2C181.2,382.8,183,391.7,183,401z">
                </path>
              </g>
            </g>
          </svg></a>

        <a href="https://www.linkedin.com/company/greenstorm-mobility/" class="inline-block mx-2 mb-4 has-text-primary"
          target="_blank" rel="noopener noreferrer" title="LinkedIn">
          <svg fill="#ffffff" height="4rem" width="4rem" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-143 145 512 512" xml:space="preserve" stroke="#ffffff">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <path
                d="M329,145h-432c-22.1,0-40,17.9-40,40v432c0,22.1,17.9,40,40,40h432c22.1,0,40-17.9,40-40V185C369,162.9,351.1,145,329,145z M41.4,508.1H-8.5V348.4h49.9V508.1z M15.1,328.4h-0.4c-18.1,0-29.8-12.2-29.8-27.7c0-15.8,12.1-27.7,30.5-27.7 c18.4,0,29.7,11.9,30.1,27.7C45.6,316.1,33.9,328.4,15.1,328.4z M241,508.1h-56.6v-82.6c0-21.6-8.8-36.4-28.3-36.4 c-14.9,0-23.2,10-27,19.6c-1.4,3.4-1.2,8.2-1.2,13.1v86.3H71.8c0,0,0.7-146.4,0-159.7h56.1v25.1c3.3-11,21.2-26.6,49.8-26.6 c35.5,0,63.3,23,63.3,72.4V508.1z">
              </path>
            </g>
          </svg>
        </a>
      </div>
    </div>

    <div class="logo-strip mt-6">
      <div class="container u-p2">
        <div class="columns has-text-centered is-vcentered is-size-5 has-text-weight-bold">
          <div class="column has-text-right-desktop">
            Tel.: <a class="is-inline-block" v-if="$whitelabel.supportPhone"
              :href="`tel:${$whitelabel.supportPhone}`">{{ $whitelabel.supportPhone }}</a>
            <!-- <a href="https://www.business.greenstorm.eu/" target="_blank" rel="noopener noreferrer"><img fetchpriority="low" loading="lazy" class="logo" v-lazy="`https://assets.urlaubsgutschein.kaufen/${this.$whitelabel.assetUrl}greenstorm-business.svg`" alt="GreenstormBusiness"/></a> -->
          </div>
          <div class="column has-text-left-desktop">
            E-Mail: <a class="is-inline-block" v-if="$whitelabel.supportMail"
              :href="`mailto:${$whitelabel.supportMail}`">{{ $whitelabel.supportMail }}</a>
            <!-- <a href="https://www.greenstorm.eu/" target="_blank" rel="noopener noreferrer"><img fetchpriority="low" loading="lazy" class="logo" v-lazy="`https://assets.urlaubsgutschein.kaufen/${this.$whitelabel.assetUrl}greenstorm-default.svg`" alt="Greenstorm"/></a> -->
          </div>
          <!-- <div class="column">
            <a href="https://www.green4rent.eu/" target="_blank" rel="noopener noreferrer"><img fetchpriority="low" loading="lazy" class="logo" v-lazy="`https://assets.urlaubsgutschein.kaufen/${this.$whitelabel.assetUrl}green4rent.svg`" alt="Green4Rent"/></a>
          </div> -->
        </div>
      </div>
    </div>

    <!-- <div class="container">
      <div class="columns is-multiline u-is-vend m-0">
        <div class="column is-12-tablet is-3-widescreen has-text-centered has-text-left-widescreen">
          <a href="/" class="is-block" v-if="$whitelabel.showFooterLogo" aria-label="Go back to Homepage">
            <img class="navbar-brand__logo" v-lazy="$whitelabel.logoFooter" :alt="$whitelabel.storeName" loading="lazy" fetchpriority="low" />
          </a>
          © {{ $whitelabel.company }}
        </div>
        <div class="column is-12-tablet is-9-widescreen has-text-right-widescreen has-text-centered is-flex-tablet footer-nav">
          <a v-if="$whitelabel.short.toLowerCase() === 'adac'" class=" is-block-mobile is-block-tablet footer-nav-link" href="https://www.adac-suedbayern.de/reisenewsletter-formular" target="_blank" title="ADAC Reise-Newsletter" rel="noopener">ADAC Reise-Newsletter</a>
          <router-link v-for="page in $whitelabel.staticContent" :key="page.Menu" :to="{name: 'markdown-page', params: {key: page.slug}}" class=" is-block-mobile is-block-tablet footer-nav-link">{{ page.menu }}</router-link>
        </div>
      </div>

      <div class="is-hidden-desktop has-text-centered">
        <a class="is-inline-block" v-if="$whitelabel.supportPhone" :href="`tel:${$whitelabel.supportMail}`"><b-icon icon="phone" size="is-small" custom-class="fa-flip-horizontal"></b-icon>&nbsp;&nbsp;{{ $whitelabel.supportPhone }}</a>
        &nbsp; &nbsp;
        <a class="is-inline-block" v-if="$whitelabel.supportMail" :href="`mailto:${$whitelabel.supportMail}`"><b-icon icon="envelope" size="is-small"></b-icon>&nbsp;&nbsp;{{ $whitelabel.supportMail }}</a>
      </div>
    </div> -->

    <!-- <div class="has-background-white" v-if="$whitelabel.short.toLowerCase() === 'greenstorm'">
      <div class="mb-5 mt-5 container">
        <div class="columns is-mobile is-multiline has-text-centered logolist">
          <div class="column is-4-tablet is-6-mobile is-one-fifth-desktop">
            <a href="https://www.greenshare.world/" target="_blank" rel="noopener"><img fetchpriority="low" loading="lazy" class="logo" v-lazy="`https://assets.urlaubsgutschein.kaufen/${this.$whitelabel.assetUrl}greenshare.svg`" alt=""/></a>
          </div>
          <div class="column is-4-tablet is-6-mobile is-one-fifth-desktop">
            <a href="https://greenstorm.eu/" target="_blank" rel="noopener"><img fetchpriority="low" loading="lazy" class="logo" v-lazy="`https://assets.urlaubsgutschein.kaufen/${this.$whitelabel.assetUrl}greenstorm.svg`" alt=""/></a>
          </div>
          <div class="column is-4-tablet is-6-mobile is-one-fifth-desktop">
            <a href="https://www.we-are.travel" target="_blank" rel="noopener"><img fetchpriority="low" loading="lazy" class="logo" v-lazy="`https://assets.urlaubsgutschein.kaufen/whitelabel/wat/logo.svg`" alt=""/></a>
          </div>
          <div class="column is-4-tablet is-6-mobile is-one-fifth-desktop">
            <a href="https://business.greenstorm.eu/firmen/" target="_blank" rel="noopener"><img fetchpriority="low" loading="lazy" class="logo" v-lazy="`https://assets.urlaubsgutschein.kaufen/${this.$whitelabel.assetUrl}myjob-mybike.svg`" alt=""/></a>
          </div>
          <div class="column is-4-tablet is-6-mobile is-one-fifth-desktop">
            <a href="https://www.green4rent.eu/" target="_blank" rel="noopener"><img fetchpriority="low" loading="lazy" class="logo" v-lazy="`https://assets.urlaubsgutschein.kaufen/${this.$whitelabel.assetUrl}green4rent.svg`" alt=""/></a>
          </div>
        </div>
      </div>
    </div> -->
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'GreenstormFooter',
  components: {},
  props: {},
  computed: {
    ...mapGetters({
      menu: 'menu',
    }),
  },
  mounted() {
    //load cookie consent plugin for greenstorm
    let ccmScript = document.createElement('script')
    ccmScript.setAttribute('src', 'https://cloud.ccm19.de/app.js?apiKey=926a2692ee716eb8f39200ec9a34606ce963dd40a7c5cdce&amp;domain=61e95c646221a94aba047b3f')
    ccmScript.setAttribute('referrerpolicy', 'origin')
    document.head.appendChild(ccmScript)
  },
}
</script>

<style scoped lang="scss">
// .footer-nav {
//   justify-content: space-between;
// }

// .logolist {
//   margin-left: 1rem;
//   margin-right: 1rem;
//   justify-content: center;
// }

footer {
  padding-bottom: 0;
  font-family: 'Roboto', BlinkMacSystemFont, -apple-system, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
  background-color: #cccccc;
}

.logo {
  //height: 55px;
  height: 40px;
}

// @media screen and (min-width: 1216px) {
//   .footer-nav {
//     justify-content: flex-end;
//   }

//   .footer-nav-link {
//     padding: 0 0.75rem;
//   }
// }

.logo-strip {
  background-color: #eee;
}

@media screen and (max-width: 1023px) {
  .logo-strip {
    padding-bottom: 5rem;
  }
}
</style>
